import { ProblemProvider } from "../../contexts/problem-context";
import ProblemContainer from "./problem-container";

export default function ProblemRoot() {
  return (
    <ProblemProvider>
      <ProblemContainer />
    </ProblemProvider>
  );
}
